module.exports = "<input id=\"{{identifier}}\"\r\n       type=\"text\"\r\n       name=\"{{identifier}}\"\r\n       [resultFormatter]=\"formatter\"\r\n       [inputFormatter]=\"formatter\"\r\n       [disabled]=\"disabled\"\r\n       class=\"form-control\"  [(ngModel)]=\"value\" [ngbTypeahead]=\"search\"\r\n       placeholder=\"{{placeholder}}\"/>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/forms/components/autocomplete/autocomplete.component.html
// module id = ./src/app/modules/forms/components/autocomplete/autocomplete.component.html
// module chunks = main